import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '@services/auth.service';
import { NotificationService } from '@services/notification.service';
import { AuthenticatedUser } from '@shared/types/authenticated-user';
import { take } from 'rxjs';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChangePasswordComponent {
  private formBuilder = inject(FormBuilder);
  private authService = inject(AuthService);
  private dialogRef =
    inject<MatDialogRef<ChangePasswordComponent>>(MatDialogRef);
  private notificationService = inject(NotificationService);
  user = inject<AuthenticatedUser>(MAT_DIALOG_DATA);

  isLoading$ = this.authService.isLoading$;
  formGroup = this.formBuilder.group({
    newPassword: ['', [Validators.required, Validators.minLength(8)]],
    repeatPassword: ['', [Validators.required, this.passwordsMatchValidator()]],
  });

  constructor() {}

  changePassword(): void {
    if (this.formGroup.invalid) return;
    this.authService
      .changePassword({
        email: this.user.email,
        newPassword: this.formGroup.get('newPassword')!.value!,
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.notificationService.showNotification('changePassword.success');
          this.dialogRef.close();
        },
        error: (err: Error) => {
          this.notificationService.showNotification(err.message);
        },
      });
  }

  private passwordsMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.touched || control.dirty) {
        return this.formGroup.get('newPassword')?.value === control.value
          ? null
          : { passwordsMismatch: true };
      }
      return null;
    };
  }
}
